import { render, staticRenderFns } from "./Earn.vue?vue&type=template&id=8454c15c&"
import script from "./Earn.vue?vue&type=script&lang=js&"
export * from "./Earn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports